export default {
    alexa: {
        tcl_assitant: "Enable Skill - TCL Assistant",
        active_code_hint: "Please enter the activation code",
        active_code_placeholder: "Activation Code",
        
        active_code_message: "On your TCL TV, press the Settings",
        active_code_message_path: " button on your remote, go to 'System' > 'Works with Alexa',",
        active_code_message_part2: "select 'Sign in' or 'Obtain code' to get the activation code.",

        active_code_message_old: "On your TCL TV, go to ",
        active_code_message_path_old: "Settings/System/Amazon Alexa/Obtain code, ",
        active_code_message_part2_old: "then enter the activation code below.",
        
        active_code_error_null: "Code couldn't be null",
        active_code_error_number: "Please input numbers",
        active_code_error_bits: "Code should be six digital numbers",
        active_code_validate: "Activate",
        active_code_message_wrong: "The activation code is incorrect or expired, please re-acquire.",
        active_code_message_exception: "Please check your network and try again.",
        check_agreements_message: "You must agree all agreements to use TCL Assistant.",
        agreements: [
            "I agree TCL to record my voice command",
            "I agree TCL's ",
            ".",
        ],
        privacy_policy: "privacy policy",

        grant_hint: "TCL would like to perform actions on your behalf",
        grant_message_success: "You have grant successfully !",
        grant_message_fail: "Grant fail, please reenter the active code",
        grant_allow: "Allow",

        console_welcome_prompt: "Welcome to TCL Alexa Console",
        empty_message: "",
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/locale/lang/en.js
// module id = null
// module chunks = 